<template>
  <div class="onboarding_comp profile-image">
    <label for="profileImage">
      <div
        class="profile-image-holder"
        :style="`background-image: url(${
          profileImage ? profileImage : pickerImg
        })`"
      ></div>
    </label>

    <input
      type="file"
      name="profile_image"
      id="profileImage"
      class="profile-image-picker"
      accept="image/*"
      @change="imageChanged($event)"
    />

    <!-- <label v-if="profileImage" for="profileImage">
      <div class="action-info">Tap to replace</div>
    </label>
    <label v-else for="profileImage">
      <div class="action-info">Tap to upload</div>
    </label> -->

    <div
      :class="{
        'display-flex align-center gap-8 justify-space-between':
          $vuetify.breakpoint.width <= 1280,
      }"
    >
      <v-btn
        v-if="$vuetify.breakpoint.width <= 1280"
        class="back-button"
        @click="$emit('actionPrevStage')"
      >
        Back
      </v-btn>
      <v-btn
        :class="{
          _disabled: !validated('skipToast'),
          'auth-bg-disabled': checkDataEmpty,
          'auth-bg-active': !checkDataEmpty,
        }"
        class="auth-button"
        @click="handleNextStage()"
      >
        Next
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      profileImage: "",
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.app.onboarding.current,
      getProfileImage: (state) => state.app.onboarding.profileImage,
    }),
    pickerImg() {
      return require("@/assets/file_upload.svg");
    },
    checkDataEmpty() {
      return this.profileImage == "";
    },
  },
  methods: {
    ...mapActions({
      gotoNextStage: "app/nextOnboardingStage",
      gotoPrevStage: "app/prevOnboardingStage",
    }),
    ...mapMutations({
      updateOnboarding: "app/updateOnboarding",
    }),
    validated(toastStatus) {
      const skipToast = toastStatus === "skipToast";

      const { profileImage } = this;
      const toValidate = [profileImage];

      const errors = ["Please upload a valid profile image"];

      const isValid = toValidate.every((item, index) => {
        if (!skipToast && !item) {
          this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });
      return isValid;
    },
    imageChanged(e) {
      if (e.target.files[0].size > 2097152) {
        this.$store.dispatch("error/showErrorToast", [
          "You can upload an image 2MB in maximum",
        ]);
        return;
      }

      this.avatar = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        (event) => {
          this.profileImage = event.target.result;
        },
        false
      );
      reader.readAsDataURL(this.avatar);
    },
    handleNextStage() {
      if (this.validated()) {
        const data = {
          profileImage: this.profileImage,
          avatar: this.avatar,
        };

        this.updateOnboarding(data);
        this.gotoNextStage(this.current + 1);
      }
    },
    handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
  },
  created() {
    this.profileImage = this.getProfileImage;
  },
};
</script>

<style lang="scss" scoped>
.profile-image-picker {
  opacity: 0 !important;
  height: 1px;
  width: 1px;
}
.profile-image-holder {
  cursor: pointer;
  position: relative;
  height: 220px;
  width: 220px;
  border-radius: 100%;
  margin: 0 auto;
  background-position: center;
  background-size: cover;

  &::after {
    content: "";
    border: 10px solid rgba(255, 255, 255, 0.2);
    width: 100%;
    height: 100%;
    /* background: red; */
    position: absolute;
    border-radius: 100%;
  }
  &:hover {
    &:after {
      border: 10px solid rgba(150, 150, 150, 0.75);
    }
  }
}

.action-info {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
}
.auth-button {
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

.back-button {
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 18.68px;
  text-align: center;
  background: #0000000d;
  height: 50px;
  border-radius: 56px;
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

@media screen and (max-width: 1280px) {
  .auth-button {
    height: 50px !important;
    border-radius: 56px;
    font-size: 18px !important;
  }
}
</style>



// WEBPACK FOOTER //
// profileImage.vue?7b45a63e